import { classNames } from '../../../utils';

type Size = 'SMALL' | 'DEFAULT' | 'LARGE' | 'XL' | 'BUTTON';
type Color =
  | 'RED'
  | 'BLUE'
  | 'GREEN'
  | 'ORANGE'
  | 'PURPLE'
  | 'WHITE'
  | 'BLACK'
  | 'DEFAULT';

const SIZE_MAP: Record<Size, string> = {
  SMALL: 'w-4 h-4 border-[3px]',
  DEFAULT: 'w-10 h-10 border-[5px]',
  LARGE: 'w-24 h-24 border-8',
  XL: 'w-48 h-48 border-10',
  BUTTON: 'w-5 h-5 border-4',
};

const COLOR_MAP: Record<Color, string> = {
  BLUE: 'border-blue',
  GREEN: 'border-green',
  ORANGE: 'border-orange',
  PURPLE: 'border-purple',
  RED: 'border-red',
  WHITE: 'border-white',
  BLACK: 'border-black',
  DEFAULT: 'border-gray',
};

interface LoaderProps {
  size?: Size;
  color?: Color;
}

function Loader({ size = 'DEFAULT', color = 'DEFAULT' }: LoaderProps) {
  return (
    <div className='relative'>
      <span
        className={classNames(
          SIZE_MAP[size],
          color === 'WHITE' ? 'border-white' : 'border-gray-light',
          'block rounded-full border-opacity-30',
        )}
      ></span>
      <span
        className={classNames(
          SIZE_MAP[size],
          COLOR_MAP[color],
          'absolute bottom-0 left-0 right-0 top-0 block animate-spin rounded-full border-l-transparent border-r-transparent border-t-transparent',
        )}
      ></span>
    </div>
  );
}

export default Loader;
